import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'editor/src/store/index';

/**
 * GAPI-61790: the bundled fonts the design's text already uses, in bundled-list order.
 * With "Use only uploaded fonts" on, the customer's picker still offers these, so text the
 * template author set in a bundled font shows its font as selected and can be switched back.
 */
const getDesignBundledFonts = createSelector(
  (state: RootState) => state.design.designData?.spreads,
  (state: RootState) => state.fonts.availableFonts,
  (spreads, availableFonts) => {
    const used = new Set<string>();
    spreads?.forEach((spread) =>
      spread.pages.forEach((page) =>
        page.groups.media?.forEach((element) => {
          if (element.type === 'text') {
            used.add(element.extra.fontFamily);
          }
        }),
      ),
    );
    return availableFonts.filter((font) => used.has(font.metadata.fontFile));
  },
);

export default getDesignBundledFonts;
